export default "__VITE_ASSET__BYIsBA9PcRyD0IoLR4zNdg__";